import { DatePipe, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { IDay, IStoreDataV3, Store } from '@df/catalog/store/store';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { LineHeightByComponent } from '@df/ui/common/line-height-by.component';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { IconLabelComponent } from 'projects/app-default/src/app/common/icon-label/icon-label.component';
import { NModalLayoutRight } from 'projects/app-default/src/app/common/modal/layout-right/modal-layout-right.component';
import { PageStoreFinderComponent } from '../page-store-finder.component';
import { PageStoreFinderStoreStatusComponent } from '../store-status/page-store-finder-store-status.component';

declare module '@df/catalog/store/store' {
    interface IStoreDataV3 {
        directions?: string;
        openingHours?: IDay[];
    }
}

@Component({
    selector: 'page-store-finder-details',
    templateUrl: 'page-store-finder-details.html',
    styleUrl: 'page-store-finder-details.scss',
    imports: [
        LineHeightByComponent,
        PageStoreFinderStoreStatusComponent,
        HrefComponent,
        IconLabelComponent,
        SlicePipe,
        DatePipe,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@DfModal({
    id: 'store-finder-details',
    position: 'right',
    config: sizeName => NModalLayoutRight.getConfig(sizeName),
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: ['S', 'M']
})
export class PageStoreFinderDetailsComponent extends UiComponent implements OnInit {
    /**
     * Store
     */
    @Input()
    store?: Store<IStoreDataV3>;

    private readonly data = inject<{ store: Store<IStoreDataV3> }>(MODAL_DATA);
    private readonly modalRef = inject(ModalRef);
    private readonly pageStoreFinderComponent = inject(PageStoreFinderComponent);

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.data) {
            this.store = this.data.store;
        }
    }

    close() {
        this.modalRef?.close();
        this.pageStoreFinderComponent?.closePreview();
    }

    /**
     * Gets day opening hours formatted
     */
    getOpeningHours(day: IDay): string {
        return day.status ? `${day.open}AM - ${day.close}PM` : 'Closed';
    }
}
